// extracted by mini-css-extract-plugin
module.exports = {"container":"Kg-z","heading":"Lg-z","links":"Mg-z","linkBtn":"Ng-z","disabled":"Og-z","linkUppercaseBold":"Pg-z","copy":"Qg-z","subCopy":"Rg-z"};